import { render } from "./newRealNameCourse.vue?vue&type=template&id=4f741c51&scoped=true"
import script from "./newRealNameCourse.vue?vue&type=script&lang=js"
export * from "./newRealNameCourse.vue?vue&type=script&lang=js"

import "./newRealNameCourse.vue?vue&type=style&index=0&id=4f741c51&lang=scss&scoped=true"

import exportComponent from "/root/workspace/zyy-iot_zyy-iot-web-v2_T3ED/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4f741c51"]])

export default __exports__